document.querySelectorAll(".discount-cards--card").forEach((item)=>{
  item.addEventListener("click",()=>{
    const textToCopy = item.getAttribute("data-coupon-code")
    navigator.clipboard.writeText(textToCopy).then(() => {
      document.querySelector(".discount-cards--notification").style.display="flex"
      document.querySelector(".discount-cards--notification").textContent = `COUPON CODE copied.`
      document.querySelector(".discount-cards--notification").style.animationName="discountCard";
      document.querySelector(".discount-cards--notification").style.animationDuration = '1s';
      document.querySelector(".discount-cards--notification").style.animationTimingFunction = 'ease-in-out';
      setTimeout(()=>{
        document.querySelector(".discount-cards--notification").style.display="none"
      },1500)
  }).catch(err => {
      console.error('Failed to copy text: ', err);
  });
  })
})